(() => {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main);
  } else {
    main();
  }

  function main() {
    const prodHandle = location.pathname.split("/").pop();

    function createBanner(img, title, desc = "", diffdate = false) {
      const wrapper = document.createElement("div");
      wrapper.className = "free_gift_banner layout2";

      wrapper.innerHTML = `
        <div class="free-gift">
          <img src="${img}" alt="">
          <div class="info-wrapper">
              <div class="title-wrapper">
              <span class="free-tag">EXCLUSIVE PROMO</span>
              <span class="title">${title}</span>
              </div>
              ${desc ? `<p class="description">${desc}</p>` : ""}
              <span class="description red-text text-semibold">Offer Ends ${diffdate? "31 May": "28 May"}</span>
          </div>
        </div>
      `;

      return wrapper;
    }

    let banner = null;

    const includedTVs = [
      "q43u-2026",
      "q55u-2026",
      "q65u-2026",
      "q75u-2026",
      "q85u-2026",

      "prism-q100-ultra-qled-google-tv",

      "q43qe-2026",
      "q55qe-2026",
      "q65qe-2026",
      "q75qe-2026",

      "u55-2026",
      "u65-2026",
      "u75-2026",

      "prism-u55-qd-mini-led",
      "u75-qled-mini-led-google",
      // "prism-u86-qd-mini-led",

      "prism-u55-ultra-qd-mini-led-4k-ai-google-tv",
      // "prism-u65-ultra-qd-mini-led-4k-ai-google-tv",
      // "prism-u75-ultra-qd-mini-led-4k-ai-google-tv",
      // "prism-u86-ultra-qd-mini-led-4k-ai-google-tv",

      // "prism-55al-google-tv",
      // "prism-65al-google-tv",

      "s32-google-tv",
      "prism-s40-google-tv",
      "prism-s43-google-tv",

      // "prism-roam-27",
      // "prism-roam-ultra-27",
      // "roam-ultra-32",
    ];

    if (prodHandle == "prism-49al") {
      banner = createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/image_f283b567-59ff-4dca-ad8b-1431b1d09a2f.png?v=1779535738",
        "$180 OFF Upsized Discount",
        "<s>$70</s> $180 OFF every purchase of a 49AL",
        true,
      );
    } else if (prodHandle == "prism-49al-240hz") {
      banner = createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/image_f283b567-59ff-4dca-ad8b-1431b1d09a2f.png?v=1779535738",
        "$160 OFF Upsized Discount",
        "<s>$70</s> $160 OFF every purchase of a 49AL 240Hz",
        true,
      );
    } else if (includedTVs.includes(prodHandle)) {
      banner = createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/TVs.png?v=1779536055",
        "Limited Time Price Drop",
        "Only available with selected TV models",
      );
    }

    const target = $(".product-single__meta > .divider");
    if (banner && target) {
      target.after(banner);
    }
  }
})();
